__turbopack_context__.v({
  "blink": "planner-face-module__OKNnMq__blink",
  "double-blink": "planner-face-module__OKNnMq__double-blink",
  "face": "planner-face-module__OKNnMq__face",
  "hoverHost": "planner-face-module__OKNnMq__hoverHost",
  "rest": "planner-face-module__OKNnMq__rest",
  "think": "planner-face-module__OKNnMq__think",
  "wander": "planner-face-module__OKNnMq__wander",
});
